// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3w7_r","inputWrap":"styles_inputWrap__1Ahgl","input":"styles_input__35ADR"};